<ng-container *transloco="let _t">

<div class="instructions" *ngIf="showManual">
	<p>{{ _t('app-report-p-0') }}</p>
	<p>{{ _t('app-report-p-1') }}</p>
	<p>{{ _t('app-report-p-2') }}</p>
	<p>{{ _t('app-report-p-3') }}<br/>
	({{ _t('app-report-p-4') }})</p>
	<p class="text-end"><button mat-raised-button (click)="showManual=false"><mat-icon>check</mat-icon>OK</button></p>
</div>

<app-tinymce [(ngModel)]="content"></app-tinymce>

</ng-container>
